import { memo } from 'react';
import cn from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Text, Label } from '@bizzabo/design-system';

type ReadViewItemProps = {
    label: string;
    value: string;
    placeholder?: string;
    clamp?: number | 'none' | 'inherit';
};

const ReadViewItem: React.FC<ReadViewItemProps> = ({ label, value, placeholder, clamp = 1 }) => {
    const classes = useStyles();

    return (
        <div>
            <Label label={label} />
            <Text
                variant="t61"
                clamp={clamp}
                className={cn(classes.text, !value && classes.placeholder)}
            >
                {value || placeholder}
            </Text>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        text: {
            padding: '4px 8px',
            marginTop: 4,
            wordBreak: 'break-all',
        },
        placeholder: {
            color: theme.palette.greys[400],
        },
    }),
    { classNamePrefix: 'people-user-profile-read-item' }
);

export default memo(ReadViewItem);
